import { OrderDirection } from "_shared/_api/ordering/order-direction";
import PaginationParameters from "_shared/_api/queries/pagination/pagination-parameters";

export class UserCoworkerFilterParameters {
  public readonly name?: string;
  public readonly email?: string;
  public readonly entityName?: string;

  public constructor(name?: string, email?: string, entityName?: string) {
    this.name = name;
    this.email = email;
    this.entityName = entityName;
  }

  public get searchParams(): URLSearchParams {
    const searchParams = new URLSearchParams();
    if (this.name) searchParams.append("name", this.name);
    if (this.email) searchParams.append("email", this.email);
    if (this.entityName) searchParams.append("entityName", this.entityName);
    return searchParams;
  }

  public isEqualTo(other: UserCoworkerFilterParameters): boolean {
    if (!other) return false;
    return this.name === other.name && this.email === other.email && this.entityName === other.entityName;
  }
}

export enum UserCoworkerOrderField {
  Name = "Name",
  Email = "Email",
  EntityName = "EntityName",
}

export class UserCoworkerOrderParameters {
  public readonly orderBy?: UserCoworkerOrderField;
  public readonly orderDir?: OrderDirection;

  public constructor(orderBy?: UserCoworkerOrderField, orderDir?: OrderDirection) {
    this.orderBy = orderBy;
    this.orderDir = orderDir;
  }

  public get searchParams(): URLSearchParams {
    const params = new URLSearchParams();
    if (this.orderBy) params.append("orderBy", this.orderBy);
    if (this.orderDir) params.append("orderDir", this.orderDir);
    return params;
  }

  public isEqualTo(other: UserCoworkerOrderParameters): boolean {
    if (!other) return false;
    return this.orderBy === other.orderBy && this.orderDir === other.orderDir;
  }
}

export default class UserCoworkerQuery {
  public readonly filterParameters: UserCoworkerFilterParameters;
  public readonly orderParameters: UserCoworkerOrderParameters;
  public readonly paginationParameters: PaginationParameters;
  public readonly query?: string;

  public constructor(
    filterParameters: UserCoworkerFilterParameters,
    orderParameters: UserCoworkerOrderParameters,
    paginationParameters: PaginationParameters,
    query?: string
  ) {
    this.paginationParameters = paginationParameters;
    this.orderParameters = orderParameters;
    this.filterParameters = filterParameters;
    this.query = query;
  }

  public get searchParams(): URLSearchParams {
    return new URLSearchParams([
      ...this.paginationParameters.searchParams,
      ...this.orderParameters.searchParams,
      ...this.filterParameters.searchParams,
      ...(this.query ? [["query", this.query]] : []),
    ]);
  }

  public isEqualTo(other: UserCoworkerQuery): boolean {
    if (!other) {
      return false;
    }
    return (
      this.filterParameters.isEqualTo(other.filterParameters) &&
      this.orderParameters.isEqualTo(other.orderParameters) &&
      this.paginationParameters.isEqualTo(other.paginationParameters) &&
      this.query === other.query
    );
  }
}
